import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "output"]

    add(event) {
        event.preventDefault()
        this._addRow(event.target.closest("tr"))
    }

    addAll(event) {
        event.preventDefault()
        this.element
            .querySelectorAll("button[data-action='admin--exploded-view--item-picker#add']:not(.disabled)")
            .forEach((button) => this._addRow(button.closest("tr")))
    }

    _addRow(source) {
        const el = source.cloneNode(true)
        this._changeButton(el)

        this.outputTarget.appendChild(el)

        this._disableButton(source)
    }

    _disableButton(el) {
        const button = el.querySelector("button")
        button.innerHTML = "Ajouté"

        button.classList.add(...["disabled", "text-success"])
        button.classList.replace("btn-white","btn-link")
    }

    _changeButton(el) {
        const button = el.querySelector("button")
        button.innerHTML = "Supprimer"
        button.dataset.action = "admin--exploded-view--item-manager#remove"

        el.querySelector("input").disabled = false
    }

}